import React, { useEffect } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { useQuery } from '@apollo/client';
import { useParams, Redirect } from 'react-router-dom';

import { Container } from '@Calix-Commerce/design-system/layout';

import { authenticationState, loadingState } from 'state/atoms';
import { SEARCH_ORDERS } from 'connectors/queries/order';
import { Title } from 'pages/Order/styledComponents';
import { PO_NUMBER_SEARCH_TYPE } from 'utils/constants';

// Decode po number value or returns the encoded value without modifications if process fails
const decodePoNumber = (encodedPoNumber) => {
  let decodedCode = encodedPoNumber;
  try {
    decodedCode = atob(encodedPoNumber);
  } catch (error) {}
  return decodedCode;
};

const PurchasedOrder = () => {
  const { accountId } = useRecoilValue(authenticationState);
  const setLoading = useSetRecoilState(loadingState);

  const { poNumber } = useParams();

  const { data, error, loading } = useQuery(SEARCH_ORDERS, {
    variables: {
      accountId,
      searchType: PO_NUMBER_SEARCH_TYPE,
      searchTerm: poNumber,
    },
  });

  useEffect(() => {
    setLoading(loading);
  }, [loading, setLoading]);

  const renderOrderContent = () => {
    if (error || !data.getAccount.searchOrders.length) {
      return (
        <span style={{ fontSize: '1.2rem' }}>
          The order for PO: {decodePoNumber(poNumber)} is not available yet. Please try again later.
        </span>
      );
    } else {
      const salesNumber = data.getAccount.searchOrders[0].salesOrderNumber;

      //If a sales number is found, redirect to Order Details page
      return <Redirect to={`/orders/${salesNumber}`} />;
    }
  };

  return loading ? null : (
    <Container>
      <Title>Order Details</Title>
      {renderOrderContent()}
    </Container>
  );
};

export { PurchasedOrder };
